import * as React from 'react';

import { cn } from 'utils/cn';

interface SpinnerProps {
    className?: string;
    size?: 'sm' | 'md' | 'lg';
    showText?: boolean;
    text?: string;
}

const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
};

export const Spinner = ({ className, size = 'md', showText = false, text = 'Loading...' }: SpinnerProps) => {
    return (
        <div className="flex items-center justify-center">
            <div className="flex flex-col items-center gap-3">
                <div
                    className={cn('animate-spin rounded-full border-b-2 border-gray-900', sizeClasses[size], className)}
                />
                {showText && <span className="text-sm text-gray-600">{text}</span>}
            </div>
        </div>
    );
};
